package pwgs.ui.scenes.custompropertieseditorscene

import kotlinx.serialization.Serializable
import visage.ds.forms.FieldModel
import visage.ds.forms.MetaFieldModel
import visage.ds.forms.SelectOption
import visage.rmi.VisageController

@VisageController(CustomPropertiesEditorSceneProps::class, CustomPropertiesEditorSceneModel::class)
interface CustomPropertiesEditor {
    fun load()
    fun create()
    fun delete(propertyName: String)
    fun update()
}

@Serializable
data class CustomPropertiesEditorSceneProps(val projectId: Long, val entityName: String)

@Serializable
class CustomPropertiesEditorSceneModel(
    val items: List<CustomPropertyItemModel>
) {
    var isLoading = true
    var editorModel: CustomPropertyEditorModel? = null
}

@Serializable
class CustomPropertyItemModel(
    val propertyName: String,
    val type: ECustomFieldType,
    val value: String,
    val isEditable: Boolean,
    val isIndexed: Boolean
)

@Serializable
class CustomPropertyEditorModel(val isUpdate: Boolean) {
    var isLoading = false
    var error: String? = null
    var nameFieldModel = FieldModel("")
    var typeFieldModel = MetaFieldModel(ECustomFieldType.String.name, listOf(
        SelectOption(ECustomFieldType.Bool.name, "Boolean"),
        SelectOption(ECustomFieldType.Float.name, "Float"),
        SelectOption(ECustomFieldType.Int.name, "Integer"),
        SelectOption(ECustomFieldType.String.name, "String"),
    ))
    var valueFieldModel = FieldModel("")
    var boolValueFieldModel = MetaFieldModel("false", listOf(
        SelectOption("true", "True"),
        SelectOption("false", "False"),
    ))
    var editableFieldModel = MetaFieldModel("true", listOf(
        SelectOption("true", "Yes"),
        SelectOption("false", "No"),
    ))
    var indexedFieldModel = MetaFieldModel("false", listOf(
        SelectOption("true", "Yes"),
        SelectOption("false", "No"),
    ))
}

@Serializable
enum class ECustomFieldType {
    Bool,
    Int,
    Float,
    String,
}